"use client";

import { env } from "@/env";
import { trackEvent } from "@/lib/analytics-events";

// WhatsApp pull-loop entry point (habit loop Workstream A, 2026-07-15):
// a click-to-wa.me link prefilled with a natural rashifal request so the
// seeker starts the free daily-reading pull relationship in one tap
// (keyword: RASHIFAL — owner decision 2026-07-15). Since #2882 the keyword
// IS the consent gate: only an explicit opt-in text (rashifal / aaj, in
// Latin or Devanagari, or this exact prefill) records a wa_pull consent
// grant — see pull_optin_keyword in the backend whatsapp_inbound.py. Other
// text may still get a reading but never makes the sender marketable, so
// the prefill below must stay PULL_OPTIN_PREFILL (pinned by the backend
// tests/test_daily_reading_pull.py).
// This is a NAVIGATION link
// (rule 39 #2 — never a monetization offer, never a second primary CTA);
// keep it low-emphasis. The number comes from config — renders nothing when
// NEXT_PUBLIC_SUPPORT_WHATSAPP is unset (dark launch).
export default function DailyReadingWhatsAppLink({ lang = "hi" }: { lang?: "en" | "hi" }) {
  const number = env.NEXT_PUBLIC_SUPPORT_WHATSAPP;
  if (!number) return null;

  const href = `https://wa.me/${number}?text=${encodeURIComponent("Mera aaj ka rashifal bhejein 🙏")}`;
  const label =
    lang === "hi"
      ? "WhatsApp पर दैनिक राशिफल — बस 'RASHIFAL' लिखें"
      : "Daily rashifal on WhatsApp — just send 'RASHIFAL'";

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="daily-reading-wa-link"
      onClick={() => trackEvent("daily_reading_wa_link_click", { lang })}
      className="mt-3 inline-flex items-center gap-1.5 text-body-small font-medium underline underline-offset-2"
      style={{ color: "var(--ish-text-muted)" }}
    >
      <span aria-hidden>{"\u{1F4F2}"}</span>
      {label}
    </a>
  );
}
